<template>
    <div id="model" v-if='is_show'>
        <!-- 关闭按钮 -->
        <img @click='hidden' src="../assets/images/common/错误.png" alt="">

        <!-- 列表 -->
        <ul>
            <li><router-link  to="/" exact>Home</router-link></li>
            <li><router-link  to="/product" exact :class='holdColor1?"active":""'>Product</router-link></li>
            <li><router-link  to="/downlaod" exact>Download</router-link></li>
            <li><router-link  to="/contact" exact>Contact</router-link></li>
            <li><router-link  to="/about" exact>About</router-link></li>
<!--            <li><router-link  to="/news" exact :class='holdColor6?"active":""'>News</router-link></li>-->
<!--            <li><router-link  to="/problem" exact :class='holdColor2?"active":""'>Q&A</router-link></li>-->
        </ul>
    </div>
</template>
<script>
export default {
    data(){
        return{
            is_show:false , // 默认隐藏菜单模态框 
            holdColor1:false, // 默认不保持菜单的颜色
            holdColor2:false, 
            holdColor6:false, 
        }
    },
    methods: {
        // 关闭菜单模态框
        hidden(){
            this.is_show=false;
        }
    },

    mounted(){
        // 显示菜单模态框
        // 得到其它组件传来值
        this.$Bus.$on('show',(data)=>{ // data为其它组件传来的值
            this.is_show=data
        })
        this.$Bus.$on('product',(data)=>{ // data为其它组件传来的值
            this.holdColor1=data
        })
        this.$Bus.$on('problem',(data)=>{ // data为其它组件传来的值
            this.holdColor2=data
        })
        this.$Bus.$on('news',(data)=>{ // data为其它组件传来的值
            this.holdColor6=data
        })
        
    }
}
</script>






<style scoped lang="less">
    /* 定义关键帧 */
    @keyframes myr{
        0%{top:0; right:-200px;}
        10%{top:0; right:-180px;}
        20%{top:0; right:-160px;}
        30%{top:0; right:-140px;}
        40%{top:0; right:-120px;}
        50%{top:0; right:-100px;}
        60%{top:0; right:-80px;}
        70%{top:0; right:-60px;}
        80%{top:0; right:-40px;}
        90%{top:0; right:-20px;}
        100%{top:0; right:0;}
    }


    #model{
        width:90%;
        height:100%;
        background:rgba(0,0,0,.8);
        position: fixed;
        top: 0;
        right: 0;
        display:flex;
        align-items: center;
        z-index: 10001;
        // 使用动画关键帧
        animation:myr 0.2s ease;

        img{
            height:2rem;
            position:absolute;
            top: 0.5rem;
            left: 0.5rem;
        }
        ul{
            width:100%;
            li{
                list-style: none;
                width:100%;
                height:3rem;
                border-top:1px solid #ccc;
                display:flex;
                justify-content: center;
                align-items: center;
                color:#fff;
                &:last-child{
                    border-bottom: 1px solid #ccc;
                }
                a{
                    color:#fff;
                }
                .active{
                    color:#257CE1; 
                    font-weight: bold;
                }
            }
            
        }
    }

    // link to的激活样式
    .router-link-active{
        color:#257CE1 !important;
        font-weight: bold !important;
    }
</style>